import clsx from "clsx";
import { Patient } from "core/types";
import { ArchivePatient } from "dsl/organisms/DeletePatientButton";
import { useEffect } from "react";
import { useTranslations } from "translations";
import { PatientIdentifier } from "./PatientIdentifier";

const DOCTOR_MENU_HEIGHT_PX = 68;

export default function DoctorPatientMenu({
  patient,
  storybookPosition,
}: {
  patient: Patient;
  storybookPosition?: "static" | "fixed";
}) {
  const translations = useTranslations();

  useEffect(() => {
    if (storybookPosition !== "static") {
      document.documentElement.style.setProperty(
        "--patient-menu-height",
        `${DOCTOR_MENU_HEIGHT_PX}px`,
      );
    }
  }, [storybookPosition]);

  return (
    <>
      <div
        className={clsx(
          "top-navbar z-40 h-patient-menu w-screen border-b border-gray-400 bg-white",
          {
            fixed: storybookPosition !== "static",
            static: storybookPosition === "static",
          },
        )}
      >
        <div className="flex w-full items-center">
          <PatientIdentifier patient={patient} />
          <ArchivePatient patient={patient} translations={translations} />
        </div>
      </div>
      {storybookPosition !== "static" && <div className="h-patient-menu" />}
    </>
  );
}
